// extracted by mini-css-extract-plugin
module.exports = {"crewMid":"style-module--crewMid--2gPJy","list":"style-module--list--2v0zF","item":"style-module--item--3NI0J","race":"style-module--race--25U7O","name":"style-module--name--2gdkH"};